<template>
  <div class="aboutUs">
    <header-mod :page-name="'aboutUs'"></header-mod>

    <div class="page">
      <div class="page_title">关于我们</div>
      <div class="intro_box">
<!--        <div class="mod_title">怡亚通集团介绍</div>-->
<!--        <div class="content">-->
<!--          <p>深圳市怡亚通供应链股份有限公司成立于 1997 年，是中国第一家上市供应链企业（股票代码： 002183），拥有500 余家分支机构，员工超万人，2018 年业绩量近 1000 亿元，是服务领域最广、规模最大的供应链服务企业，连续三年入围中企联“中国 500 强”榜单。</p>-->
<!--          <p>▪ 服务全球 100 多家世界 500 强企业，2600 多个国内外知名品牌。</p>-->
<!--          <p>▪ 分销商品品类达 40 万种。</p>-->
<!--          <p>▪ 在中国 320 多个主要城市(包括香港)和东南亚、美国等国家构建服务平台。</p>-->
<!--          <p>▪ 专业服务人员遍布中国 1-6 线城市及乡镇。</p>-->
<!--          <p>▪ 覆盖全国城镇市场的 200 多万的终端门店。</p>-->
<!--          <p>▪ 拥有物流可控车辆近 10000 辆，年业务运营能力逾 1000 亿。</p>-->
<!--          <p>▪ 全国共七大供应链基地，总面积逾 40 万平方米。</p>-->
<!--        </div>-->
        <div class="mod_title">怡信未来介绍</div>
        <div class="content">
          <p>深圳市怡信未来科技有限公司专注于供应链场景，连接银行等各类金融机构，整合平台商户资源，为供应链平台下游小微企业提供基于供应链场景的信贷产品，致力于为更多中小微企业主提供金融服务，联合银行机构共同打造符合小微企业需求的爆款信贷产品。公司自成立以来，始终以市场需求为导向，以深化服务内容，完善服务手段为经营理念，利用互联网信息技术+供应链的全新商业模式，依托怡信未来完善的供应链服务体系，强大的资源共享能力和大数据服务能力，为客户提供一站式解决方案，满足客户多元化的服务需求。</p>
        </div>
        <div class="mod_title">EA生意小助手介绍</div>
        <div class="content">
          <p>EA生意小助手是一款供应链垂直细分行业场景的智能大数据贷款，最高500万，随借随还，最低日息万3.5、月综合费率最低0.59%，秒级到账。有效破解小微客户“轻资产、无担保”的融资难题，将智能与服务合二为一，为小微企业注入生机与活力。依托怡信未来智能决策引擎，为快消品行业平台客户提供全流程线上化智能金融服务。该产品基于供应链真实交易场景，依托交易链条中商流、物流、资金流和信息流数据，以强大风控体系配合金融科技力量。</p>
        </div>
      </div>
    </div>

    <footer-mod></footer-mod>
  </div>
</template>

<script>
import headerMod from "@/components/header"
import footerMod from "@/components/footer"
export default {
  components: {
    HeaderMod: headerMod,
    FooterMod: footerMod
  },
  data() {
    return {

    }
  },
  methods: {

  },
  created() {
    document.title = '关于我们 - 怡信未来科技'
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue